'use client';

import { useEffect } from 'react';

import { clearCombinedFlowCookie } from '@/modules/experiments/helpers/clearCombinedFlowCookie';
import { setCombinedFlowCookie } from '@/modules/experiments/helpers/setCombinedFlowCookie';

type Props = {
  hasEntryParam: boolean;
};

/**
 * Keeps the Combined Signup & Checkout cookie in sync with the checkout entry
 * param on the first auth pages (`/login`, `/signup`).
 * Query params get lost on subsequent auth pages so we refer to the cookie for
 * the rest of the flow.
 *
 * This is also what protects us from non-checkout signup flows from seeing
 * the combined checkout components (which could happen after an abandoned checkout
 * flow), as if there's no query param passed then the cookie is cleared.
 */
export function CombinedFlowCookieSync({ hasEntryParam }: Props) {
  useEffect(() => {
    if (hasEntryParam) {
      void setCombinedFlowCookie();
    } else {
      void clearCombinedFlowCookie();
    }
  }, [hasEntryParam]);

  return null;
}
